import React from 'react';
import '../social_icons/style.css';
import {
 Col,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { aboutUser} from '../../../const/about_user';

function SocialIcons() {
  return (
         <Col xl={12} className="social-icons">
   

          {aboutUser.socialLinks.map(el=> (
          
          el.link !=="" && <a href={el.link} target="_blank" rel="noopener noreferrer" key={el.id}>
          <FontAwesomeIcon className={el.className} icon={el.icon} />
          </a> )

          )}

         </Col>
  );
}

export default SocialIcons;
